import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    Center,
    IconButton,
    Divider
  } from '@chakra-ui/react';

import { FiEdit3 } from 'react-icons/fi';
import AddEditTagItem from './AddEditTagItem';

export default function ManageTags( { tags, showButtonText } ){
    const { isOpen, onOpen, onClose } = useDisclosure()
    return (
      <>
        <Center>
        {showButtonText ? 
            <Button mr={2} size='sm' variant={'outline'} colorScheme={'teal'} icon={<FiEdit3/>} onClick={onOpen}> Manage Tags</Button>
            :
            <IconButton size='sm' variant={'outline'} colorScheme={'teal'} icon={<FiEdit3/>} onClick={onOpen}></IconButton>
         }        
        </Center>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Manage Tags</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                {tags && tags.map((tag, i) => {
                    return(
                        <AddEditTagItem key={tag.id} tagID={tag.id} tagName={tag.name} tagColor={tag.color} action='Update'/>
                    )
                })}
                <Divider mb={5} mt={5} />
                <AddEditTagItem key='add' tagID={null} action='Add' />
            </ModalBody>
  
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={onClose}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
}